<template>
  <div class="detail-main" v-if="data_ok">
    <Header ref="header"/>
    <div class="main-1200-width padding-bottom-40">
      <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item,index) in detailData.crumbs" :key="index" :to="{path: 'Screen', name: 'Screen', params: {cate_id: item.id}}">{{item.name}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{detailData.title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail-head">
        <div class="detail-carousel">
          <el-carousel height="420px" :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item v-for="(item,index) in detailData.images" :key="index">
              <img class="detail-carousel-img" :src="$url.cdn(item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="detail-other">
          <div class="detail-other-main">
            <div class="detail-other-box">
              <p class="detail-other-title">{{detailData.title}}</p>
              <p v-if="is_login" class="detail-other-price">价格：￥{{price}}<span class="detail-other-vip-price" v-if="vip_price > 0"><img src="@/assets/vip_price.png" alt="会员价">￥{{vip_price}}</span></p>
              <p v-else class="detail-other-price">价格：**** <a href="/login">登录后查看</a></p>
              <p v-if="!is_login" class="detail-member"><a href="/register">注册会员享受折扣</a></p>
            </div>
            <div class="detail-spec-box">
              <div class="spec" v-for="(item,index) in detailData.skus" :key="index" :data-spec_id="item.id">
                <div class="spec_name">{{item.name}}</div>
                <div class="spec_list">
                  <div v-for="(item1,index1) in item.children" :key="index1"
                    :data-spec_price="detailData.sku_prices[index1].original_price"
                    :data-spec_vip_price="detailData.sku_prices[index1].price"
                    :data-goods_spec="detailData.sku_prices[index1].id"
                    :data-min_number="detailData.sku_prices[index1].min_number"
                    :data-spec_id="item.id"
                    :data-spec_item_id="item1.id"
                    class="spec_item" :class="spec_item_id === item1.id ?'spec_active':''"
                    @click="specClick"
                    >{{item1.name}}</div>
                </div>
              </div>
              <div class="shopping_amount">
                <div class="spec_name">购买数量</div>
                <el-input-number class="shopping_amount_input" v-model="amount" :min="minNumber" label="描述文字"></el-input-number>
              </div>
            </div>
            <div class="detail-other-btns">
              <div class="detail-other-btn detail-other-btn1" @click="purchase">
                <span class="el-icon el-icon-shopping-cart-2"></span>订购
              </div>
              <div :class="is_collection" class="detail-other-btn detail-other-btn2" @click="collect">
                <span :class="is_collection_icon" class="el-icon el-icon-star-off"></span><span>{{collect_title}}</span>
              </div>
            </div>
            <div class="detail-other-tag">
              <div class="detail-other-tag-item" v-for="(item, index) in detailData.service" :key="index"><span class="el-icon el-icon-circle-check"></span>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-info">
        <div class="detail-left-recommend">
          <div class="detail-left-recommend-title">达人选购</div>
          <div class="detail-left-recommend-list">
            <a v-for="(item,index) in recommend" :key="index" class="recommend-item" :href="'/GoodsDetail?id='+item.id" :title="item.name">
              <img class="recommend-item-img" :src="$url.cdn(item.image)" alt="">
              <div class="recommend-item-title">{{item.name}}</div>
              <div class="recommend-item-price">¥{{ formatPrice(item.price) }}</div>
            </a>
          </div>
        </div>
        <div class="detail-right-info">
          <el-tabs type="border-card">
            <el-tab-pane label="商品详情">
              <div class="detail-right-content">
                <div class="pro-disclaimer-area ma-to-20" v-html="detailData.content"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="规格参数">
              <div class="detail-right-spec">
                <p class="detail-right-spec-title">商品属性</p>
                <div class="detail-right-spec-info">
                  <p v-for="(item_a,index_a) in detailData.params" :key="index_a">{{item_a.title}}：{{item_a.content}}</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import Header from "@/globalComponents/Header";
  import Footer from "@/globalComponents/Footer";
  import $store from "@/store";
  import userApi from "@/api/user.js";
  import goodsApi from "@/api/goods.js";
  export default {
    data() {
      return {
        data_ok           : false,
        active            : 0,
        price             : 0,
        vip_price         : 0,
        amount            : 1,
        minNumber         : 1,
        spec_id           : 0,
        spec_item_id      : 0,
        goods_spec_id     : 0,
        is_collection     : false,
        is_collection_icon: false, //'el-icon-star-on'
        detailData        : {},
        recommend         : [],
        collect_ok        : false,
        collect_title     : '收藏',
      };
    },
    computed: {
      ...mapGetters(['is_login']),
      skuPrices() {
        let skuPrices = this.detailData.sku_prices;
        if (this.detailData.is_sku) {
          skuPrices.forEach((item) => {
            item.goods_sku_id_arr = item.goods_sku_ids.split(',');
          });
        }
        return skuPrices;
      }
    },
    created() {
      this.getData();
    },
    methods   : {
      formatPrice(e) {
          return e.length === 1 ? e[0] : e.join('~');
      },
      // 当前所选规格下，获取所有有库存的 skuPrice
      getCanUseSkuPrice() {
        let newPrice = [];

        for (let price of skuPrices.value) {
          if (price.stock <= 0) {
            // || price.stock < this.goodsNum		不判断是否大于当前选择数量，在 uni-number-box 判断，并且 取 stock 和 goods_num 的小值
            continue;
          }
          var isOk = true;

          state.currentSkuArray.forEach((sku) => {
            // sku 不为空，并且，这个 条 skuPrice 没有被选中,则排除
            if (sku.toString() != '' && price.goods_sku_id_arr.indexOf(sku.toString()) < 0) {
              isOk = false;
            }
          });

          if (isOk) {
            newPrice.push(price);
          }
        }

        return newPrice;
      },
      specClick(e) {
        let data = e.target;
        this.price = data.dataset.spec_price;
        this.vip_price = data.dataset.spec_vip_price;
        this.spec_id = parseInt(data.dataset.spec_id);
        this.spec_item_id = parseInt(data.dataset.spec_item_id);
        this.goods_spec_id = parseInt(data.dataset.goods_spec);
        this.amount = parseInt(data.dataset.min_number)
        this.minNumber = parseInt(data.dataset.min_number)
      },
      async getData() { //获取页面数据
        let {data: detailData} = await goodsApi.detail(this.$route.query['id'])

        this.price = this.formatPrice(detailData.price)
        this.detailData = detailData;


        // if (this.detailData.sku_prices.length > 0 && this.detailData.spec[0].spec_item.length > 0) {
        //   this.spec_item_id = this.detailData.spec[0].spec_item[0].id;
        //   this.spec_id = this.detailData.spec[0].id;
        //   this.price = this.detailData.spec[0].spec_item[0].price;
        //   this.vip_price = this.detailData.spec[0].spec_item[0].vip_price;
        //   this.goods_spec_id = this.detailData.spec[0].spec_item[0].goods_spec_item;
        // }

        if (this.detailData.favorite) {
          this.is_collection = 'yes';
          this.collect_title = '取消收藏';
          this.is_collection_icon = 'el-icon-star-on';
        }

        let {data: recommend}  = await goodsApi.list({category_id: detailData.category_ids[0], list_rows: 5})
        this.recommend = recommend.data;


        this.collect_ok = true;
        this.data_ok = true;
      },
      async purchase() { //购买
        let data = {
          goods_id: this.$route.query['id'],
          goods_num: this.amount,
          id: this.goods_spec_id,
        };

        if (this.detailData.sku_prices.length > 0 && data.id === 0) {
          this.$message({
            showClose: true,
            message  : '请选择规格',
            type     : 'error'
          });
          return false;
        }

        await $store.dispatch('cart/add', data);
        this.$refs.header.getCartNum();
        this.$message({
          showClose: true,
          message  : '已添加到购物车',
          type     : 'success'
        });

      },
      async collect() { //收藏
        await userApi.favorite.do(this.detailData.id);
        this.collect_ok = true;
        if (this.is_collection) {
          this.is_collection = false;
          this.collect_title = '收藏';
          this.is_collection_icon = false;
        } else {
          this.is_collection = 'yes';
          this.collect_title = '取消收藏';
          this.is_collection_icon = 'el-icon-star-on';
        }
      }
    },
    components: {
      Header,
      Footer
    }
  };
</script>
<style lang="less" scoped>
  @import url("detail.less");
</style>



// WEBPACK FOOTER //
// src/components/goods/detail.vue